module.exports = __webpack_public_path__ + "static/img/chair-jizhi.12a889b8.png";